module.exports = __webpack_public_path__ + "img/gradient.104a3389.png";